import React, { useEffect, useState } from "react";
import { useRive } from "@rive-app/react-canvas";
import "../../../styles/utils/loading/SlidePuzzleLoading.scss";
import SlidePuzzle from "../../slidePuzzle/SlidePuzzle";
import { getCustomLoadingImage } from "../../../api/customAPI";
import PuzzleClearModal from "../modal/PuzzleClearModal";
import MusicToggleButton from "../button/MusicToggleButton";
import useAppTranslation from "../../../hooks/useAppTranslation";

const ArialRiveAnimation = ({ level }) => {
  const getRiveSrc = (lvl) => {
    if (lvl === 3)
      return "/images/utils/loading/slidePuzzleLoading/happy-arial.riv";
    if (lvl === 2)
      return "/images/utils/loading/slidePuzzleLoading/surprise-arial.riv";
    if (lvl === 1)
      return "/images/utils/loading/slidePuzzleLoading/normal-arial.riv";
    return null;
  };

  const src = getRiveSrc(level);
  const { RiveComponent } = useRive({
    src,
    autoplay: true,
  });

  return <RiveComponent />;
};

export default function SlidePuzzleLoading() {
  const { t } = useAppTranslation("components/utils/slidePuzzleLoading");
  const [time, setTime] = useState(100);
  const [level, setLevel] = useState(1);
  const [showModal, setShowModal] = useState(false);
  const [imageUrl, setImageUrl] = useState("");
  const USER_ID = localStorage.getItem("userID");

  useEffect(() => {
    handleMakeImage();
  }, []);

  useEffect(() => {
    const timer = setInterval(() => {
      setTime((prevTime) => (prevTime > 0 ? prevTime - 1 : 0));
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const handleSolved = () => {
    // 퍼즐 완성 시 모달 표시
    setTimeout(() => setShowModal(true), 500);
  };

  const handleNextLevel = () => {
    if (level < 3) {
      setLevel((prev) => prev + 1);
    } else {
      setLevel(1);
    }
    handleMakeImage(); // 다음 단계로 넘어갈 때 이미지 교체
    setShowModal(false);
  };

  const handleMakeImage = async () => {
    const res = await getCustomLoadingImage({ user_id: USER_ID });
    setImageUrl(res.data.creation);
  };

  return (
    <div className="slide-puzzle-loading-wrap">
      <div className="slide-puzzle-loading-header">
        <figure className="slide-puzzle-asset1">
          <img
            src="/images/utils/loading/slidePuzzleLoading/asset1.svg"
            alt={t("alts.decoration")}
          />
        </figure>
        <div className="music-toggle-btn-loading-wrapper">
          <MusicToggleButton />
        </div>
        <figure className="slide-puzzle-asset2">
          <img
            src="/images/utils/loading/slidePuzzleLoading/asset1.svg"
            alt={t("alts.decoration")}
          />
        </figure>
        <figure className="slide-puzzle-asset3">
          <img
            src="/images/utils/loading/slidePuzzleLoading/asset2.svg"
            alt={t("alts.decoration")}
          />
        </figure>
        <figure className="slide-puzzle-asset4">
          <img
            src="/images/utils/loading/slidePuzzleLoading/asset3.svg"
            alt={t("alts.decoration")}
          />
        </figure>
        <figure className="slide-puzzle-asset-rope">
          <img
            src="/images/utils/loading/slidePuzzleLoading/rope.svg"
            alt={t("alts.rope")}
          />
        </figure>
        <div className="slide-puzzle-loading-title">
          {t("title")}
        </div>
        <div className="slide-puzzle-loading-clock">
          <figure>
            <img
              src="/images/utils/loading/slidePuzzleLoading/clock.svg"
              alt={t("alts.clock")}
            />
          </figure>
          <div className="slide-puzzle-loading-clock-time">
            <span>{t("timeRemaining")}</span>
            <p>{time}</p>
          </div>
        </div>
      </div>
      <div className="slide-puzzle-loading-body">
        <div className="slide-puzzle-loading-level">
          <p>{t("level")}</p>
          {Array.from({ length: level }, (_, i) => i + 1).map((item) => (
            <figure key={item}>
              <img
                src="/images/utils/loading/slidePuzzleLoading/star.svg"
                alt={t("alts.star")}
              />
            </figure>
          ))}
        </div>
        <div className="slide-puzzle-wrap">
          <SlidePuzzle img={imageUrl} level={level} onSolved={handleSolved} />
        </div>
        <div className="slide-puzzle-loading-right">
          <div className="slide-puzzle-loading-right-top">
            <p>{t("answerImage")}</p>
            <div>
              <figure>
                <img src={imageUrl} alt={t("alts.answerImage")} />
              </figure>
            </div>
          </div>
          <button
            className="slide-puzzle-loading-right-bottom"
            onClick={handleMakeImage}
          >
            <img
              src="/images/utils/loading/slidePuzzleLoading/change.svg"
              alt={t("alts.change")}
            />
            <p>{t("actions.changeImage")}</p>
          </button>
        </div>
        <div className={`arial-rive-wrap level-${level}`}>
          <ArialRiveAnimation level={level} key={level} />
        </div>
      </div>

      {showModal && (
        <PuzzleClearModal level={level} handleNextLevel={handleNextLevel} />
      )}
    </div>
  );
}
